import React from "react";
import CampaignList from "./CampaignList";
import AddUpdateCampaignPage from "./AddUpdateCampaignPage";
import { ICustomerPageState, ICampaignPageProps } from "interfaces/Index";
import HeadingText from "components/common/HeadingText/HeadingText";
export default class CampaignPage extends React.Component<
  ICampaignPageProps,
  ICustomerPageState
> {
  constructor(props: ICampaignPageProps) {
    super(props);
    this.state = {
      isEdit: false,
      isCampaignAddUpdate: false,
      showAddUpdatePage: false,
      selectedCampaign: null,
      searchText: "",
      currentListPosition: 0,
    };
  }
  renderAddUpdateCampaignPage = () => {
    const {
      isLoading,
      isError,
      error,
      createCampaign,
      history,
      location,
      match,
      updateCampaign,
      isCampaignUpdated,
      isCampaignCreated,
      fetchProductBrands,
      productBrands,
    } = this.props;

    const { isEdit, selectedCampaign } = this.state;
    return (
      <AddUpdateCampaignPage
        fetchProductBrands={fetchProductBrands}
        backButtonHandler={this.navigateBackToListingPage}
        campaign={selectedCampaign}
        productBrands={productBrands}
        isEdit={isEdit}
        isLoading={isLoading}
        isError={isError}
        error={error}
        createCampaign={createCampaign}
        updateCampaign={updateCampaign}
        isCampaignCreated={isCampaignCreated}
        isCampaignUpdated={isCampaignUpdated}
        history={history}
        location={location}
        match={match}
      />
    );
  };

  renderCampaignListing = () => {
    const {
      error,
      campaigns,
      fetchCampaigns,
      isCampaignFetched,
      isCampaignCreated,
      isCampaignFetchedError,
      isCampaignUpdated,
      pagination,
    } = this.props;
    const { searchText, currentListPosition, isCampaignAddUpdate } = this.state;
    return (
      <>
        <section className="main-heading-margin">
          <HeadingText text="Campaigns" isMainHeading={true} />
        </section>
        <CampaignList
          fetchCampaigns={fetchCampaigns}
          campaigns={campaigns}
          pagination={pagination}
          isLoading={isCampaignFetched}
          isError={isCampaignFetchedError}
          error={error}
          addUpdatePageHandler={this.toggleAddUpdateCampaignPage}
          retainedSearchText={searchText}
          isCampaignCreated={isCampaignCreated}
          isCampaignFetched={isCampaignFetched}
          isCampaignUpdated={isCampaignUpdated}
          isCampaignAddedorUpdated={isCampaignAddUpdate}
          currentListPosition={currentListPosition}
        />
      </>
    );
  };

  toggleAddUpdateCampaignPage = (
    isEdit: boolean = false,
    selectedCampaign: any = null,
    searchText: string = "",
    currentScroll: number = 0
  ) => {
    const { showAddUpdatePage } = this.state;
    this.setState({
      showAddUpdatePage: !showAddUpdatePage,
      isEdit: isEdit,
      selectedCampaign: selectedCampaign,
      searchText: searchText,
      currentListPosition: currentScroll,
    });
  };

  navigateBackToListingPage = (isAddUpdate: boolean) => {
    const { showAddUpdatePage, searchText, currentListPosition } = this.state;
    this.setState({
      showAddUpdatePage: !showAddUpdatePage,
      isCampaignAddUpdate: isAddUpdate,
      searchText: isAddUpdate ? "" : searchText,
      currentListPosition: isAddUpdate ? 0 : currentListPosition,
    });
  };

  render() {
    const { showAddUpdatePage } = this.state;
    return (
      <div>
        {showAddUpdatePage
          ? this.renderAddUpdateCampaignPage()
          : this.renderCampaignListing()}
      </div>
    );
  }
}
